import {ArtfactKind, IEntity, Metadata, Search} from '@mrp-brasil/nick-data-commons';
import {ICoreCrudService} from '@mrp-brasil/nick-node-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, of} from 'rxjs';
import {concatMap, flatMap, map, toArray} from 'rxjs/operators';
import {HttpHook} from '../http/http.hook';

@HookClass('entity')
export class EntityHook extends BaseHook {

    @Hook('086edb82-9697-4522-875d-73001a1ee931')
    public createOrUpdate(inputArtifact: any): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {

                let loopArtifact = inputArtifact.object.data;

                if (inputArtifact.kind != ArtfactKind.ARRAY)
                    loopArtifact = [inputArtifact];

                const saveItems = loopArtifact.map((value: any) => {
                    if (value && value.hasOwnProperty('object') && value.object.hasOwnProperty('data'))
                        return value.object.data;
                    return value;
                });
                // adicionar uma pequena lógica temporária de filtro

                if (!saveItems.length) {
                    const artifact = new NickProcessArtfact();
                    artifact.object = {
                        data: []
                    };
                    artifact.kind = ArtfactKind.ANY;
                    return of(artifact);
                }

                if (saveItems.length == 1)
                    return service.save(saveItems[0], null, null, null, {where: inputArtifact.object.where, upsert: inputArtifact.object.upsert})
                        .pipe(map((entity: IEntity) => {
                            const returnArtifact = new NickProcessArtfact();
                            returnArtifact.kind = ArtfactKind.ANY;

                            returnArtifact.object = {
                                data: entity && entity.toJSON ? entity.toJSON() : entity,
                                model: inputArtifact.object.model
                            };

                            if (inputArtifact.kind == ArtfactKind.ARRAY)
                                returnArtifact.object.data = [returnArtifact.object.data];

                            return returnArtifact;
                        }));


                return service.bulkSave(saveItems, inputArtifact.object.options)
                    .pipe(map((entity: IEntity[]) => {
                        const returnArtifact = new NickProcessArtfact();
                        returnArtifact.kind = ArtfactKind.ANY;

                        if (inputArtifact.kind != ArtfactKind.ARRAY)
                            returnArtifact.object = {
                                data: entity[0] ? entity[0].toJSON ? entity[0].toJSON() : entity[0] : entity,
                                model: inputArtifact.object.model
                            };
                        else
                            returnArtifact.object = {
                                data: entity.map((entity: IEntity) => entity && entity.toJSON ? entity.toJSON() : entity),
                                // metadata: cacheMetadata,
                                model: inputArtifact.object.model
                            };

                        return returnArtifact;
                    }));
            }));
    }

    @Hook('6eb53c3c-b858-40cf-a116-33a40d28c088')
    public findOne(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                let include: any[] = null;

                if (inputArtifact.object.config && inputArtifact.object.config.include) {
                    include = inputArtifact.object.config.include;

                    const organize$ = (include: any[], associations: any) => {
                        include.forEach((item: any) => {
                            if (item.where?.hasOwnProperty('__customWhere')) {
                                if (!item.where['$and'])
                                    item.where['$and'] = [];

                                item.where['$and'].push(Search.literalFn(item.where.__customWhere));
                                delete item.where.__customWhere;
                            }

                            if (!associations[item.as]) {
                                throw new Error(`Association not found ${item.as} - ${item.tableName}`);
                            } else {
                                item.model = associations[item.as].target;
                            }

                            if (item.include)
                                organize$(item.include, item.model.associations);
                        });
                    };

                    organize$(include, service.associations);
                }


                if (!inputArtifact.object.config)
                    inputArtifact.object.config = {};

                if (inputArtifact.object.config.raw == undefined)
                    inputArtifact.object.config.raw = true;

                return service.findOne(inputArtifact.object.data.id, null, include, {
                    raw: inputArtifact.object.config?.raw,
                    attributes: inputArtifact?.object?.config?.attributes
                })
                    .pipe(concatMap((entity: IEntity) => {
                        inputArtifact.object.data = entity && entity.toJSON ? entity.toJSON() : entity;
                        return service.getMetadata()
                            .pipe(map((metadata: Metadata) => {
                                inputArtifact.object.metadata = metadata;
                                return inputArtifact;
                            }));
                    }));
            }));
    }

    @Hook('930d2caa-65d7-4ced-96b7-268ce6f69ba0')
    public findOneWhere(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        let cacheMetadata: Metadata;
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                const repo = (service as any).repository;
                let loopArtifact = inputArtifact.object.data;

                if (inputArtifact.kind != ArtfactKind.ARRAY)
                    loopArtifact = [inputArtifact];

                return from(loopArtifact)
                    .pipe(flatMap((singleInputArtifact: NickProcessArtfact) => {
                        let include: any[] = null;

                        if (singleInputArtifact.object.config && singleInputArtifact.object.config.include) {
                            include = singleInputArtifact.object.config.include;

                            const organize$ = (include: any[], associations: any) => {
                                include.forEach((item: any) => {
                                    if (item.where?.hasOwnProperty('__customWhere')) {
                                        if (!item.where['$and'])
                                            item.where['$and'] = [];

                                        item.where['$and'].push(Search.literalFn(item.where.__customWhere));
                                        delete item.where.__customWhere;
                                    }

                                    if (!associations[item.as]) {
                                        throw new Error(`Association not found ${item.as} - ${item.tableName}`);
                                    } else {
                                        item.model = associations[item.as].target;
                                    }

                                    if (item.include)
                                        organize$(item.include, item.model.associations);
                                });
                            };

                            organize$(include, service.associations);
                        }

                        if (singleInputArtifact.object.config && singleInputArtifact.object.config.where && singleInputArtifact.object.data) {
                            singleInputArtifact.object.data = Object.assign(singleInputArtifact.object.data, singleInputArtifact.object.config.where);
                        }

                        const search = new Search(singleInputArtifact.object.data);
                        return service.getMetadata()
                            .pipe(concatMap((metadata: Metadata) => {
                                search.setMetadata(metadata);
                                return search.buildWhere()
                                    .pipe(concatMap((_where: any) => {
                                        if (_where.length)
                                            _where = {$or: Search.literalFn(_where)};

                                        if (inputArtifact.object?.config?.ignoreWhere)
                                            _where = inputArtifact.object.data;

                                        return service.findOneWhere(_where, include, inputArtifact?.object?.config?.sort, inputArtifact?.object?.config?.group, null, inputArtifact?.object?.config?.attributes, inputArtifact.object.config?.raw)
                                            .pipe(map((entity: IEntity) => {
                                                singleInputArtifact.object.data = entity && entity.toJSON ? entity.toJSON() : entity;

                                                if (cacheMetadata) {
                                                    singleInputArtifact.object.metadata = cacheMetadata;
                                                    return singleInputArtifact;
                                                }

                                                cacheMetadata = metadata;
                                                singleInputArtifact.object.metadata = metadata;
                                                return singleInputArtifact;
                                            }));
                                    }));
                            }));


                    }, 6), toArray())
                    .pipe(map((result: NickProcessArtfact[]) => {
                        if (inputArtifact.kind != ArtfactKind.ARRAY)
                            return result[0];

                        const returnArtifact = new NickProcessArtfact();
                        returnArtifact.kind = ArtfactKind.ANY;

                        returnArtifact.object = {
                            data: result.map((artifact: NickProcessArtfact) => artifact.object.data),
                            metadata: cacheMetadata,
                            model: cacheMetadata ? cacheMetadata.modelType : null
                        };

                        return returnArtifact;
                    }));
            }));
    }

    @Hook('d3aaa6ff-9718-43a6-97b1-ee690c402d3d')
    public findAll(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                let include: any[] = null;
                const repo = (service as any).repository;

                if (inputArtifact.object.config && inputArtifact.object.config.include) {
                    include = inputArtifact.object.config.include;

                    const organize$ = (include: any[], associations: any) => {
                        include.forEach((item: any) => {
                            if (item.where?.hasOwnProperty('__customWhere')) {
                                if (!item.where['$and'])
                                    item.where['$and'] = [];

                                item.where['$and'].push(Search.literalFn(item.where.__customWhere));
                                delete item.where.__customWhere;
                            }

                            if (!associations[item.as]) {
                                throw new Error(`Association not found ${item.as} - ${item.tableName}`);
                            } else {
                                item.model = associations[item.as].target;
                            }

                            if (item.include)
                                organize$(item.include, item.model.associations);
                        });
                    };

                    organize$(include, service.associations);
                }

                if (inputArtifact.object?.config?.attributes) {
                    inputArtifact.object.config.attributes = inputArtifact.object?.config?.attributes.map((col: string) => {
                        if (col.indexOf('|fn:count') >= 0) {
                            const colName = col.replace('|fn:count', '');
                            return [service.fn('COUNT', service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}Count`];
                        } else if (col.indexOf('|fn:date_trunc') >= 0) {
                            let ops = col.split('|');
                            const colName = ops[0];
                            ops = ops[1].split(':');
                            return [service.fn('date_trunc', `${ops[2]}`, service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}`];
                        } else if (col.indexOf('|fn:sum') >= 0) {
                            const colName = col.replace('|fn:sum', '');
                            return [service.fn('SUM', service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}Sum`];
                        } else if (col.indexOf('|fn:max') >= 0) {
                            const colName = col.replace('|fn:max', '');
                            return [service.fn('MAX', service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}Max`];
                        }
                        return col;
                    });
                }

                if (inputArtifact.object?.config?.group) {
                    inputArtifact.object.config.group = inputArtifact.object?.config?.group.map((col: string) => {
                        if (col.indexOf('|fn:count') >= 0) {
                            const colName = col.replace('|fn:count', '');
                            return [service.fn('COUNT', service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}Count`];
                        } else if (col.indexOf('|fn:date_trunc') >= 0) {
                            let ops = col.split('|');
                            const colName = ops[0];
                            ops = ops[1].split(':');
                            return [service.fn('date_trunc', `${ops[2]}`, service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}`];
                        } else if (col.indexOf('|fn:sum') >= 0) {
                            const colName = col.replace('|fn:sum', '');
                            return [service.fn('SUM', service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}Sum`];
                        } else if (col.indexOf('|fn:max') >= 0) {
                            const colName = col.replace('|fn:max', '');
                            return [service.fn('MAX', service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}Max`];
                        }

                        return col;
                    });
                }

                if (inputArtifact.object?.config?.sort) {
                    inputArtifact.object.config.sort = inputArtifact.object?.config?.sort.map((_col: any) => {
                        let col: string = _col;


                        if (_col instanceof Array)
                            col = _col[0];
                        else
                            _col = [, 'ASC'];

                        if (_col[1] instanceof Array) {
                            //     ORDER BY case when "tournament_person_order"."stopKind" = 0 then "tournament_person_order"."price" end ASC,
                            // case when "tournament_person_order"."stopKind" = 1 then "tournament_person_order"."price" end DESC

                            // "stopKind|0|ASC",
                            // "stopKind|1|DESC"
                            col = service.literal(_col[1].map((query: string) => {
                                const fields = query.split('|');
                                return `case when "${service.repository.model.name}"."${fields[0]}" = ${fields[1]} then "${service.repository.model.name}"."${_col[0]}" end ${fields[2]}`;
                            }).join(','));

                            return col;
                        }

                        if (col.indexOf('|fn:count') >= 0) {
                            const colName = col.replace('|fn:count', '');
                            return [service.fn('COUNT', service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}Count`];
                        } else if (col.indexOf('|fn:date_trunc') >= 0) {
                            let ops = col.split('|');
                            const colName = ops[0];
                            ops = ops[1].split(':');
                            return [service.fn('date_trunc', `${ops[2]}`, service.col(`"${service.repository.model.name}"."${colName}"`))];
                        } else if (col.indexOf('|fn:sum') >= 0) {
                            const colName = col.replace('|fn:sum', '');
                            return [service.fn('SUM', service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}Sum`];
                        } else if (col.indexOf('|fn:max') >= 0) {
                            const colName = col.replace('|fn:max', '');
                            return [service.fn('MAX', service.col(`"${service.repository.model.name}"."${colName}"`)), `${colName}Max`];
                        }
                        return [col, _col[1]];
                    });
                }

                const search = new Search(inputArtifact.object.data);
                return service.getMetadata()
                    .pipe(concatMap((metadata: Metadata) => {
                        search.setMetadata(metadata);
                        return search.buildWhere()
                            .pipe(concatMap((_where: any) => {
                                if (_where.length)
                                    _where = {$or: Search.literalFn(_where)};

                                if (inputArtifact.object?.config?.ignoreWhere)
                                    _where = inputArtifact.object.data;

                                return service.findAll(_where, include, null, inputArtifact?.object?.config?.sort, inputArtifact?.object?.config?.group, inputArtifact?.object?.config?.attributes, inputArtifact.object.config?.raw)
                                    .pipe(map((entities: IEntity[]) => {
                                        inputArtifact.object.data = entities.map((entity: IEntity) => entity && entity.toJSON ? entity.toJSON() : entity);
                                        inputArtifact.object.metadata = metadata;
                                        return inputArtifact;
                                    }));
                            }));
                    }));
            }));
    }


    @Hook('9bfed52b-28bb-4f2f-bd13-ee7f0ee3d37c')
    public page(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.database)
            .pipe(concatMap((service: ICoreCrudService) => {
                let include: any[] = null;
                let sort: any[] = null;

                if (inputArtifact.object.config && inputArtifact.object.config.include) {
                    include = inputArtifact.object.config.include;

                    const organize$ = (include: any[], associations: any) => {
                        include.forEach((item: any) => {
                            if (item.where?.hasOwnProperty('__customWhere')) {
                                if (!item.where['$and'])
                                    item.where['$and'] = [];

                                item.where['$and'].push(Search.literalFn(item.where.__customWhere));
                                delete item.where.__customWhere;
                            }

                            if (!associations[item.as]) {
                                throw new Error(`Association not found ${item.as} - ${item.tableName}`);
                            } else {
                                item.model = associations[item.as].target;
                            }

                            if (item.include)
                                organize$(item.include, item.model.associations);
                        });
                    };

                    organize$(include, service.associations);
                }

                if (inputArtifact.object.config && inputArtifact.object.config.sort) {
                    sort = inputArtifact.object.config.sort;
                }

                const search = new Search(inputArtifact.object.data);
                return service.getMetadata()
                    .pipe(concatMap((metadata: Metadata) => {
                        search.setMetadata(metadata);
                        return search.buildWhere()
                            .pipe(concatMap((_where: any) => {
                                if (_where.length)
                                    _where = {$or: Search.literalFn(_where)};

                                if (inputArtifact.object?.config?.ignoreWhere)
                                    _where = inputArtifact.object.data;

                                return service.countAll(_where, include)
                                    .pipe(concatMap((total) => {
                                        inputArtifact.object.config.total = total;
                                        inputArtifact.object.config.totalPages = Math.ceil(total / inputArtifact?.object?.config.pageSize);
                                        const offset = (inputArtifact?.object?.config.page - 1) * inputArtifact?.object?.config.pageSize;

                                        return service.findPage(_where, inputArtifact?.object?.config.pageSize, offset, include, null, sort, inputArtifact?.object?.config.group, inputArtifact?.object?.config.attributes, inputArtifact.object.config?.raw)
                                            .pipe(map((entities: IEntity[]) => {
                                                inputArtifact.object.data = entities.map((entity: IEntity) => entity && entity.toJSON ? entity.toJSON() : entity);
                                                inputArtifact.object.metadata = metadata;
                                                return inputArtifact;
                                            }));
                                    }));


                            }));
                    }));
            }));
    }


    @Hook('1551b46b-1212-4f4d-8487-5e8a8d12a404')
    public count(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                let include: any[] = null;
                const repo = (service as any).repository;

                if (inputArtifact.object.config && inputArtifact.object.config.include) {
                    include = inputArtifact.object.config.include;

                    const organize$ = (include: any[], associations: any) => {
                        include.forEach((item: any) => {
                            if (item.where?.hasOwnProperty('__customWhere')) {
                                if (!item.where['$and'])
                                    item.where['$and'] = [];

                                item.where['$and'].push(Search.literalFn(item.where.__customWhere));
                                delete item.where.__customWhere;
                            }

                            if (!associations[item.as]) {
                                throw new Error(`Association not found ${item.as} - ${item.tableName}`);
                            } else {
                                item.model = associations[item.as].target;
                            }

                            if (item.include)
                                organize$(item.include, item.model.associations);
                        });
                    };

                    organize$(include, service.associations);
                }

                const search = new Search(inputArtifact.object.data);
                return service.getMetadata()
                    .pipe(concatMap((metadata: Metadata) => {
                        search.setMetadata(metadata);
                        return search.buildWhere()
                            .pipe(concatMap((_where: any) => {
                                if (_where.length)
                                    _where = {$or: Search.literalFn(_where)};

                                return service.countAll(_where, include);
                            }));
                    }))
                    .pipe(concatMap((count: number) => {
                        inputArtifact.object.data = count;
                        return of(inputArtifact);
                    }));
            }));
    }

    @Hook('2a9687f4-8eae-48d6-806e-bef204c6e841')
    public delete(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                if (inputArtifact.object.where) {
                    return service.deleteWhere(inputArtifact.object.where, inputArtifact.object.config?.permanent)
                        .pipe(map(() => {
                            return inputArtifact;
                        }));
                } else {
                    if (inputArtifact.object.data.id instanceof Array)
                        return from(inputArtifact.object.data.id)
                            .pipe(concatMap((id: string) => {
                                return service.delete(id, inputArtifact.object.config?.permanent);
                            }), toArray())
                            .pipe(map(() => {
                                return inputArtifact;
                            }));

                    return service.delete(inputArtifact.object.data.id, inputArtifact.object.config?.permanent)
                        .pipe(concatMap((entity: IEntity) => {
                            inputArtifact.object.data = entity;
                            return of(inputArtifact);
                        }));
                }
            }));
    }

    @Hook('6d753c44-6bc1-4b4c-87e3-31e28230bff9')
    public findMaxWhere(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                return service.max(inputArtifact.object.config.column, inputArtifact.object.data)
                    .pipe(concatMap((result: any) => {
                        // todo: o max pode ser para qualquer tipo de campo, verificar no metadata qual o tipo para fazer o tratamento correto.
                        inputArtifact.object.data = {};
                        if (result == null || isNaN(result))
                            inputArtifact.object.data[inputArtifact.object.config.column] = 0;
                        else
                            inputArtifact.object.data[inputArtifact.object.config.column] = result;

                        return of(inputArtifact);
                    }));
            }));
    }

    @Hook('a74af8cc-d5b4-45bc-a80c-af42cb030c30')
    public empty(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        if (!inputArtifact.object.model)
            return of(inputArtifact);

        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                return service.getMetadata()
                    .pipe(map((metadata: Metadata) => {
                        inputArtifact.object.metadata = metadata;
                        return inputArtifact;
                    }));
            }));
    }

    @Hook('587d12d0-25ee-4b69-99cc-d5e779ee4fa7')
    public modelEntity(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const metadataHookInput = new NickProcessArtfact();
        metadataHookInput.kind = ArtfactKind.ANY;
        metadataHookInput.object = {
            config: {
                url: `/api/model/metadata/${inputArtifact.object.model}`
            }
        };
        return this.make(HttpHook)
            .pipe(concatMap((httpHook: HttpHook) => httpHook.get(metadataHookInput)));
    }

    @Hook('abf46626-06e9-43fa-ae06-9a14171881f0')
    public export(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {

        // let _service: any;
        //
        // let modelEntity: any;
        // const fields: any[] = [];
        // const fieldsModel: any[] = [];
        // let modelDbXref: any;
        // let hookModel: any[];

        // const modelService = 'f9b070ee-daa1-4a14-922e-62cfcd8d625d';
        // const fieldsService = '690d8463-4367-4fd0-9200-3e2399b6288c';
        // const fieldsModelService = 'ce4741dc-b7bb-4aff-aa1b-20655853ff0b';
        // const modelDbXrefService = '81cf939e-baff-4c06-b4ce-7f9c05bcd8a6';
        // const hookModelService = '290d516e-d2de-440b-98e3-c95f08e5c78c';
        return of(inputArtifact);

        // return this.crudService
        //     .pipe(concatMap((services: ICoreCrudService[]) => from(services)))
        //     .pipe(concatMap((service: ICoreCrudService) => {
        //         _service = service;
        //         return service.getModelById(modelService);
        //     }))
        //     .pipe(concatMap((service: ICoreCrudService) => service.findOne(inputArtifact.object.data.modelId)))
        //     .pipe(concatMap((model: any) => {
        //         modelEntity = model;
        //         return _service.getModelById(fieldsModelService)
        //             .pipe(concatMap((service: ICoreCrudService) =>
        //                 service.findAll({modelId: model.id}, null, null,
        //                     [{
        //                         model: _service._repository.models.field,
        //                         as: 'field'
        //                     }])));
        //     }))
        //     .pipe(concatMap((fieldsXrefs: any[]) => {
        //
        //         fieldsXrefs.forEach((fieldXref) => {
        //             const field = fieldXref.get();
        //             fields.push(field.field);
        //             delete field.field;
        //             fieldsModel.push(field);
        //         });
        //
        //         const outputArtifact = new NickProcessArtfact();
        //         outputArtifact.kind = ArtfactKind.ANY;
        //         outputArtifact.object = {
        //             info: {
        //                 filename: `${modelEntity.name.toLowerCase()}-entity-seed.json`,
        //                 contentType: 'application/json'
        //             }
        //         };
        //
        //         const entityOutput = {
        //             id: uuid(),
        //             author: 'Alysson Guimarães',
        //             data: [
        //                 {
        //                     systemId: '774bfaa5-fab2-4528-80f1-293afb8eb71d',
        //                     table: 'model',
        //                     rows: [modelEntity]
        //                 },
        //                 {
        //                     systemId: '774bfaa5-fab2-4528-80f1-293afb8eb71d',
        //                     table: 'field',
        //                     rows: fields
        //                 },
        //                 {
        //                     systemId: '774bfaa5-fab2-4528-80f1-293afb8eb71d',
        //                     table: 'field_model_xref',
        //                     rows: fieldsModel
        //                 },
        //                 {
        //                     table: 'model_db_xref',
        //                     service: 'ModelDbXrefService',
        //                     systemId: '774bfaa5-fab2-4528-80f1-293afb8eb71d',
        //                     rows: ['']
        //                 },
        //                 {
        //                     table: 'hook_model_xref',
        //                     systemId: '774bfaa5-fab2-4528-80f1-293afb8eb71d',
        //                     rows: ['']
        //                 }
        //             ]
        //         };
        //
        //         outputArtifact.object.buffer = JSON.stringify(entityOutput);
        //
        //         return of(outputArtifact);
        //     }));

    }

    @Hook('1029466b-02ec-4986-a51a-20ca2352a30d')
    public sum(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                const search = new Search(inputArtifact.object.data);
                return service.getMetadata()
                    .pipe(concatMap((metadata: Metadata) => {
                        search.setMetadata(metadata);
                        return search.buildWhere()
                            .pipe(concatMap((_where: any) => {
                                if (_where.length)
                                    _where = {$or: Search.literalFn(_where)};

                                return service.sum(inputArtifact.object.config.column, _where);
                            }));
                    }))
                    .pipe(concatMap((sum: number) => {
                        inputArtifact.object.data = sum;
                        return of(inputArtifact);
                    }));
            }));
    }

    @Hook('c72323c2-6fa3-49a5-a618-1f478b77d6c4')
    public reindex(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                return service.reindex();
            }))
            .pipe(map((result: any) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = result;
                return outputArtifact;
            }));
    }

    @Hook('417d9aaa-7054-443c-86ac-58eed2f235de')
    public executeQuery(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return this.crud(inputArtifact.object.model, inputArtifact.object.dbId)
            .pipe(concatMap((service: ICoreCrudService) => {
                if (inputArtifact.object.query instanceof Array) {
                    inputArtifact.object.query = inputArtifact.object.query.join(' ');
                }

                return service.executeQuery(inputArtifact.object.query, inputArtifact.object.options);
            }))
            .pipe(map((result: any) => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                outputArtifact.object = result;
                return outputArtifact;
            }));
    }

}
